import { LocaleType } from 'src/modules/common/types'


const  getLocale = () => {
  const lang: LocaleType = window.localStorage.getItem('locale') as any || LocaleType.ZH_CN
  return lang
}

const  setLocale = (lang: LocaleType, realReload = true) => {
  
  if (getLocale() !== lang) {
      window.localStorage.setItem('locale', lang || '')
      
      if (realReload) {
          window.location.reload()
      }
  }
}

export  {
  getLocale,
  setLocale,
}